import { Box } from "@/components/essentials/box";
import { Button } from "@/components/essentials/button";
import { PlanEmptyBox } from "@/components/fragments/plan/plan-empty-box";
import Link from "next/link";
import { type VFC } from "react";
import { emptyTestId } from "./const";

export const Empty: VFC = () => (
  <div data-testid={emptyTestId}>
    <Box mb="16">
      <PlanEmptyBox />
    </Box>
    <Button as={Link} href="/" w="100%" size="lg" styleVariant="mono">
      ホームへ戻る
    </Button>
  </div>
);
